// extracted by mini-css-extract-plugin
export default {"customSecondaryColor":"maroon","combBlueColor":"#004896","combAquaColor":"#28abe2","primaryColor":"#0d6efd","secondaryColor":"#6c757d","darkColor":"#212529"};